export default [
  {
    component: "TitleText",
    data: {
      title: "chapter-4.slice-1.title",
      text: "chapter-4.slice-1.text",
    }
  },
  {
    component: "CarouselFull",
    data: {
      backgroundColor: "white",
      title: "chapter-4.slice-2.title",
      carousel: [
        {
          image: {
            alt: "chapter-4.slice-2.image-1.alt",
            src: "chapter-4.slice-2.image-1.src",
            // src: require('@/assets/images/chapter-4_slice-2_image-1.jpg'),
          },
          author: "chapter-4.slice-2.image-1.caption",
          anchor: "#section-3",
        },
        {
          image: {
            alt: "chapter-4.slice-2.image-2.alt",
            src: "chapter-4.slice-2.image-2.src",
            // src: require('@/assets/images/chapter-4_slice-2_image-2.jpg'),
          },
          author: "chapter-4.slice-2.image-2.caption",
          anchor: "#section-4",
        },
        {
          image: {
            alt: "chapter-4.slice-2.image-3.alt",
            src: "chapter-4.slice-2.image-3.src",
            // src: require('@/assets/images/chapter-4_slice-2_image-3.jpg'),
          },
          author: "chapter-4.slice-2.image-3.caption",
          anchor: "#section-5",
        },
        {
          image: {
            alt: "chapter-4.slice-2.image-4.alt",
            src: "chapter-4.slice-2.image-4.src",
            // src: require('@/assets/images/chapter-4_slice-2_image-4.jpg'),
          },
          author: "chapter-4.slice-2.image-4.caption",
          anchor: "#section-6",
        },
        {
          image: {
            alt: "chapter-4.slice-2.image-5.alt",
            src: "chapter-4.slice-2.image-5.src",
            // src: require('@/assets/images/chapter-4_slice-2_image-5.jpg'),
          },
          author: "chapter-4.slice-2.image-5.caption",
          anchor: "#section-8",
        },
        {
          image: {
            alt: "chapter-4.slice-2.image-6.alt",
            src: "chapter-4.slice-2.image-6.src",
            // src: require('@/assets/images/chapter-4_slice-2_image-6.jpg'),
          },
          author: "chapter-4.slice-2.image-6.caption",
          anchor: "#section-9",
        },
     ]
    }
  },
  {
    component: "CarouselSplit",
    data: {
      title: "chapter-4.slice-3.title",
      category: "chapter-4.slice-3.category",
      description: "chapter-4.slice-3.description",
      cta: "chapter-4.slice-3.cta",
      ctaLabel: "chapter-4.slice-3.cta_label",
      carousel: [
        {
          image: {
            alt: "chapter-4.slice-3.image-1.alt",
            src: "chapter-4.slice-3.image-1.src",
            // src: require('@/assets/images/chapter-4_slice-3_image-1.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-3.image-2.alt",
            src: "chapter-4.slice-3.image-2.src",
            // src: require('@/assets/images/chapter-4_slice-3_image-2.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-3.image-3.alt",
            src: "chapter-4.slice-3.image-3.src",
            // src: require('@/assets/images/chapter-4_slice-3_image-3.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-3.image-4.alt",
            src: "chapter-4.slice-3.image-4.src",
            // src: require('@/assets/images/chapter-4_slice-3_image-4.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-3.image-5.alt",
            src: "chapter-4.slice-3.image-5.src",
            // src: require('@/assets/images/chapter-4_slice-3_image-5.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-3.image-6.alt",
            src: "chapter-4.slice-3.image-6.src",
            // src: require('@/assets/images/chapter-4_slice-3_image-6.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-3.image-7.alt",
            src: "chapter-4.slice-3.image-7.src",
            // src: require('@/assets/images/chapter-4_slice-3_image-7.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-3.image-8.alt",
            src: "chapter-4.slice-3.image-8.src",
            // src: require('@/assets/images/chapter-4_slice-3_image-8.jpg'),
          },
        }
      ]
    }
  },
  {
    component: "CarouselSplit",
    data: {
      title: "chapter-4.slice-4.title",
      category: "chapter-4.slice-4.category",
      description: "chapter-4.slice-4.description",
      cta: "chapter-4.slice-4.cta",
      ctaLabel: "chapter-4.slice-4.cta_label",
      carousel: [
        {
          image: {
            alt: "chapter-4.slice-4.image-1.alt",
            src: "chapter-4.slice-4.image-1.src",
            // src: require('@/assets/images/chapter-4_slice-4_image-1.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-4.image-2.alt",
            src: "chapter-4.slice-4.image-2.src",
            // src: require('@/assets/images/chapter-4_slice-4_image-2.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-4.image-3.alt",
            src: "chapter-4.slice-4.image-3.src",
            // src: require('@/assets/images/chapter-4_slice-4_image-3.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-4.image-4.alt",
            src: "chapter-4.slice-4.image-4.src",
            // src: require('@/assets/images/chapter-4_slice-4_image-4.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-4.image-5.alt",
            src: "chapter-4.slice-4.image-5.src",
            // src: require('@/assets/images/chapter-4_slice-4_image-5.jpg'),
          },
        }
      ]
    }
  },
  {
    component: "TextDoubleCol",
    data: {
      title: "chapter-4.slice-5.title",
      category: "chapter-4.slice-5.category",
      description: "chapter-4.slice-5.description",
      cta: "chapter-4.slice-5.cta",
      ctaLabel: "chapter-4.slice-5.cta_label",
      leftCol: [
        {
          image: {
            alt: "chapter-4.slice-5.image-1.alt",
            src: "chapter-4.slice-5.image-1.src",
            // src: require('@/assets/images/chapter-4_slice-5_image-1.jpg'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-5.image-3.alt",
            src: "chapter-4.slice-5.image-3.src",
            // src: require('@/assets/images/chapter-4_slice-5_image-3.jpg'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-5.image-5.alt",
            src: "chapter-4.slice-5.image-5.src",
            // src: require('@/assets/images/chapter-4_slice-5_image-5.jpg'),
          }
        },
      ],
      rightCol: [
        {
          image: {
            alt: "chapter-4.slice-5.image-2.alt",
            src: "chapter-4.slice-5.image-2.src",
            // src: require('@/assets/images/chapter-4_slice-5_image-2.jpg'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-5.image-4.alt",
            src: "chapter-4.slice-5.image-4.src",
            // src: require('@/assets/images/chapter-4_slice-5_image-4.jpg'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-5.image-6.alt",
            src: "chapter-4.slice-5.image-6.src",
            // src: require('@/assets/images/chapter-4_slice-5_image-6.jpg'),
          }
        },
      ]
    }
  },
  {
    component: "SimpleParagraph",
    data: {
      title: "chapter-4.slice-6.title",
      category: "chapter-4.slice-6.category",
      description: "chapter-4.slice-6.description",
      cta: "chapter-4.slice-6.cta",
      ctaLabel: "chapter-4.slice-6.cta_label",
    }
  },
  {
    component: "CarouselParallax",
    data: {
      carousel: [
        {
          image: {
            alt: "chapter-4.slice-6.image-1.alt",
            src: "chapter-4.slice-6.image-1.src",
            // src: require('@/assets/images/chapter-4_slice-6-image-1.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-6.image-2.alt",
            src: "chapter-4.slice-6.image-2.src",
            // src: require('@/assets/images/chapter-4_slice-6-image-2.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-6.image-3.alt",
            src: "chapter-4.slice-6.image-3.src",
            // src: require('@/assets/images/chapter-4_slice-6-image-3.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-6.image-4.alt",
            src: "chapter-4.slice-6.image-4.src",
            // src: require('@/assets/images/chapter-4_slice-6-image-4.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-6.image-5.alt",
            src: "chapter-4.slice-6.image-5.src",
            // src: require('@/assets/images/chapter-4_slice-6-image-5.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-6.image-6.alt",
            src: "chapter-4.slice-6.image-6.src",
            // src: require('@/assets/images/chapter-4_slice-6-image-6.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-6.image-7.alt",
            src: "chapter-4.slice-6.image-7.src",
            // src: require('@/assets/images/chapter-4_slice-6-image-7.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-6.image-8.alt",
            src: "chapter-4.slice-6.image-8.src",
            // src: require('@/assets/images/chapter-4_slice-6-image-8.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-6.image-9.alt",
            src: "chapter-4.slice-6.image-9.src",
            // src: require('@/assets/images/chapter-4_slice-6-image-9.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-6.image-10.alt",
            src: "chapter-4.slice-6.image-10.src",
            // src: require('@/assets/images/chapter-4_slice-6-image-10.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-6.image-11.alt",
            src: "chapter-4.slice-6.image-11.src",
            // src: require('@/assets/images/chapter-4_slice-6-image-11.png'),
          }
        },
      ]
    }
  },
  {
    component: "CarouselSplit",
    data: {
      title: "chapter-4.slice-7.title",
      category: "chapter-4.slice-7.category",
      description: "chapter-4.slice-7.description",
      cta: "chapter-4.slice-7.cta",
      ctaLabel: "chapter-4.slice-7.cta_label",
      carousel: [
        {
          image: {
            alt: "chapter-4.slice-7.image-1.alt",
            src: "chapter-4.slice-7.image-1.src",
            // src: require('@/assets/images/chapter-4_slice-7_image-1.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-7.image-2.alt",
            src: "chapter-4.slice-7.image-2.src",
            // src: require('@/assets/images/chapter-4_slice-7_image-2.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-7.image-3.alt",
            src: "chapter-4.slice-7.image-3.src",
            // src: require('@/assets/images/chapter-4_slice-7_image-3.jpg'),
          },
        }, {
          image: {
            alt: "chapter-4.slice-7.image-4.alt",
            src: "chapter-4.slice-7.image-4.src",
            // src: require('@/assets/images/chapter-4_slice-7_image-4.jpg'),
          },
        }
      ]
    }
  },

  {
    component: 'SimpleParagraph',
    data: {
      title: "chapter-4.slice-8.title",
      category: "chapter-4.slice-8.category",
      description: "chapter-4.slice-8.description",
      cta: "chapter-4.slice-8.cta",
      ctaLabel: "chapter-4.slice-8.cta_label",
    }
  },
  {
    component: "VerticalGallery",
    data: {
      images: [
        {
          alt: "chapter-4.slice-8.image-1.alt",
          src: "chapter-4.slice-8.image-1.src",
          // src: require('@/assets/images/chapter-4_slice-8_image-1.jpg'),
          offset: 0,
          width: 60.25,
          speed: 0.5,
          ratio: 964/1312,
        }, {
          alt: "chapter-4.slice-8.image-2.alt",
          src: "chapter-4.slice-8.image-2.src",
          // src: require('@/assets/images/chapter-4_slice-8_image-2.jpg'),
          offset: -62.125,
          width: 62.5,
          speed: 1,
          ratio: 1001/1249,
        }, {
          alt: "chapter-4.slice-8.image-3.alt",
          src: "chapter-4.slice-8.image-3.src",
          // src: require('@/assets/images/chapter-4_slice-8_image-3.jpg'),
          offset: -4.625,
          width: 52.875,
          speed: 0.5,
          ratio: 424/529,
        }, {
          alt: "chapter-4.slice-8.image-4.alt",
          src: "chapter-4.slice-8.image-4.src",
          // src: require('@/assets/images/chapter-4_slice-8_image-4.jpg'),
          offset: -24.125,
          width: 55.375,
          speed: -0.5,
          ratio: 887/1171,
        }
      ]
    }
  },

  {
    component: "CarouselParallax",
    data: {
      landscape: true,
      title: "chapter-4.slice-9.title",
      subtitle: "chapter-4.slice-9.subtitle",
      carousel: [
        {
          image: {
            alt: "chapter-4.slice-9.image-1.alt",
            src: "chapter-4.slice-9.image-1.src",
            // src: require('@/assets/images/chapter-4_slice-9-image-1.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-9.image-2.alt",
            src: "chapter-4.slice-9.image-2.src",
            // src: require('@/assets/images/chapter-4_slice-9-image-2.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-9.image-3.alt",
            src: "chapter-4.slice-9.image-3.src",
            // src: require('@/assets/images/chapter-4_slice-9-image-3.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-9.image-4.alt",
            src: "chapter-4.slice-9.image-4.src",
            // src: require('@/assets/images/chapter-4_slice-9-image-4.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-9.image-5.alt",
            src: "chapter-4.slice-9.image-5.src",
            // src: require('@/assets/images/chapter-4_slice-9-image-5.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-9.image-6.alt",
            src: "chapter-4.slice-9.image-6.src",
            // src: require('@/assets/images/chapter-4_slice-9-image-6.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-9.image-7.alt",
            src: "chapter-4.slice-9.image-7.src",
            // src: require('@/assets/images/chapter-4_slice-9-image-7.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-9.image-8.alt",
            src: "chapter-4.slice-9.image-8.src",
            // src: require('@/assets/images/chapter-4_slice-9-image-8.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-9.image-9.alt",
            src: "chapter-4.slice-9.image-9.src",
            // src: require('@/assets/images/chapter-4_slice-9-image-9.png'),
          }
        },
        {
          image: {
            alt: "chapter-4.slice-9.image-10.alt",
            src: "chapter-4.slice-9.image-10.src",
            // src: require('@/assets/images/chapter-4_slice-9-image-10.png'),
          }
        },
      ]
    }
  },
  {
    component: "SimpleParagraph",
    data: {
      description: "chapter-4.slice-10.description",
      cta: "chapter-4.slice-10.cta",
      ctaLabel: "chapter-4.slice-10.cta_label",
      position: 'center',
    }
  },
  {
    component: "NextChapter",
    data: {
      image: {
        alt: "chapter-4.next.image.alt",
        src: "chapter-4.next.image.src",
        // src: require('@/assets/images/chapter-4_next_image.jpg'),
      },
      nextChapter: "chapter-4.next.title"
    }
  }
]